import { GetAllFiltersPersonalManagmentDTO, GetAllPersonalManagementDTO, PersonalManagementDTO, PersonalManagementUpdateDTO } from "./dto"
import { PersonalManagementServiceImpl } from "./serviceImpl"

export interface PersonalManagementService {
    CreatePersonalManagementResource(): Promise<string>
    DownloadSPrev3(id:string): Promise<void>
    DownloadCV(id:string): Promise<void>
    UpdatePersonalManagementResource(data: PersonalManagementUpdateDTO, id: string): Promise<void>
    GetAllPersonalManagementResources(filters: GetAllFiltersPersonalManagmentDTO): Promise<GetAllPersonalManagementDTO>
    GetByIdPersonalManagementResources(id:string): Promise<PersonalManagementDTO>
}

export function NewPersonalManagementService(): PersonalManagementService {
    return new PersonalManagementServiceImpl();
}